import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "container px-0" }
const _hoisted_4 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_5 = { class: "col-sm-6 col-md-3 mb-1" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative" }
const _hoisted_7 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_11 = { class: "d-flex align-items-center position-relative" }
const _hoisted_12 = { class: "card-title align-items-start flex-column mt-0" }
const _hoisted_13 = { class: "card-body py-3" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Id Transaksi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Pesanan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Pesanan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Harga"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Pesanan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Catatan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-left pl-3" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_25 = {
  key: 1,
  class: "badge badge-primary"
}
const _hoisted_26 = {
  key: 2,
  class: "badge badge-warning"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/search.svg",
  alt: ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/search.svg",
  alt: ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/checkout.svg",
  alt: ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "row mt-5 mb-5" }
const _hoisted_46 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_47 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_48 = ["label", "value"]
const _hoisted_49 = { class: "p-3" }
const _hoisted_50 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_51 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.companyId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
                  placeholder: "Pilih Company Dahulu",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listSekolah,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihCompany($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Status Pesanan",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tag) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.tag]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", _hoisted_12, [
                  (_ctx.aksesDownload == true)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                        class: "btn btn-md btn-primary"
                      }, " Download "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _hoisted_16,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item._id), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.companyName), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.productData.title), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(item.quantity), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.productData.price * item.quantity), 1),
                      _createElementVNode("td", _hoisted_23, [
                        (item.verifiedStatus == 'Tidak Komplit')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.verifiedStatus), 1))
                          : _createCommentVNode("", true),
                        (item.verifiedStatus == 'Terverifikasi')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.verifiedStatus), 1))
                          : _createCommentVNode("", true),
                        (item.verifiedStatus == 'Menunggu Konfirmasi')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.verifiedStatus), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(item.note), 1),
                      _createElementVNode("td", _hoisted_28, [
                        (item.productData.type === 'PRODUK & JASA')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "me-2 symbol symbol-35px",
                              title: "View",
                              style: {"cursor":"pointer"},
                              "data-bs-target": "#kt_modal_2",
                              onClick: ($event: any) => (
                      _ctx.$router.push({
                        path:
                          '/superadmin/cart-product/detail-order/' +
                          this.companyId +
                          '/' +
                          item._id,
                        query: {
                          cardDesign: item.stepVerification.cardDesign,
                          cardData: item.stepVerification.cardData,
                          cardPrint: item.stepVerification.cardPrint,
                        },
                      })
                    )
                            }, _hoisted_31, 8, _hoisted_29))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "me-2 symbol symbol-35px",
                              title: "View",
                              style: {"cursor":"pointer"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_2",
                              onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/cart-product/detail-product-order/' +
                          this.companyId +
                          '/' +
                          item._id
                      )
                    )
                            }, _hoisted_35, 8, _hoisted_32)),
                        _createElementVNode("a", {
                          class: "me-2 symbol symbol-35px",
                          title: "View",
                          style: {"cursor":"pointer"},
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_2",
                          onClick: ($event: any) => (_ctx.clickview(item))
                        }, _hoisted_38, 8, _hoisted_36),
                        _createElementVNode("a", {
                          class: "me-2 symbol symbol-35px",
                          title: "View",
                          style: {"cursor":"pointer"},
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_2",
                          onClick: ($event: any) => (_ctx.handleDelete(index, item))
                        }, _hoisted_41, 8, _hoisted_39)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_42, _hoisted_44))
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_48))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("ul", _hoisted_51, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}